import { useState } from "react";
import { Download, Film, Image as ImageIcon, Loader2, Route } from "lucide-react";
import { toast } from "sonner";

const ITEMS = [
  ["cards", "Story cards", "PNG · 1080×1350 · WhatsApp-ready image of the 3 step cards", ImageIcon, "image/png"],
  ["path", "Growing path", "PNG · 1080×1080 · the Register → Log in → Open Video path with tips", Route, "image/png"],
  ["video", "Video (MP4)", "MP4 · 1080×1080 · 19 s animated walkthrough, plays inline on WhatsApp", Film, "video/mp4"],
  ["gif", "Animated GIF", "GIF · 540×540 · loops automatically (~0.5 MB)", Film, "image/gif"],
];

export const HowToDownloads = ({ authFetch }) => {
  const [busy, setBusy] = useState("");
  const [preview, setPreview] = useState(null);
  const get = async (kind, label) => {
    setBusy(kind);
    try {
      for (let i = 0; i < 90; i += 1) {
        const s = await (await authFetch(`/admin/howto/asset/${kind}/status`)).json();
        if (s.error) throw new Error(s.error);
        if (s.ready) break;
        if (i === 89) throw new Error("Still preparing — please try again in a minute");
        await new Promise((res) => setTimeout(res, 2000));
      }
      const r = await authFetch(`/admin/howto/asset/${kind}`);
      if (!r.ok) throw new Error((await r.json().catch(() => ({}))).detail || "Could not prepare the file");
      const blob = await r.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = `positivelife-how-to-open-the-video-${kind}.${kind === "video" ? "mp4" : kind === "gif" ? "gif" : "png"}`;
      document.body.appendChild(a); a.click(); a.remove();
      if (kind === "cards" || kind === "path") setPreview({ url, label });
      else setTimeout(() => URL.revokeObjectURL(url), 60000);
      toast.success(`${label} downloaded`);
    } catch (e) { toast.error(e.message); } finally { setBusy(""); }
  };
  return (
    <div className="mt-5 rounded-2xl border border-[#1A2E26]/10 bg-white/70 p-4" data-testid="howto-downloads">
      <p className="text-sm font-semibold flex items-center gap-2"><Download size={14} className="text-[#C86A51]" /> Share with participants — download</p>
      <p className="text-[11px] text-muted-foreground mt-1 mb-3">Ready-made files in the website colours using the title above. Send them on WhatsApp to the batch group or to anyone who is new. The video may take ~20 seconds to prepare the first time.</p>
      <div className="grid sm:grid-cols-2 gap-2">
        {ITEMS.map(([kind, label, desc, Icon]) => (
          <button type="button" key={kind} data-testid={`howto-download-${kind}`} onClick={() => get(kind, label)} disabled={!!busy} className="flex items-center gap-3 rounded-xl border border-border bg-white px-3 py-2.5 text-left hover:border-[#C86A51]/50 hover:shadow-sm transition-[border-color,box-shadow] disabled:opacity-60">
            <span className="grid place-items-center w-9 h-9 rounded-lg bg-[#1A2E26] text-white shrink-0">{busy === kind ? <Loader2 size={16} className="animate-spin" /> : <Icon size={16} />}</span>
            <span className="min-w-0"><span className="block text-sm font-medium">{busy === kind ? "Preparing…" : label}</span><span className="block text-[11px] text-muted-foreground leading-snug">{desc}</span></span>
          </button>
        ))}
      </div>
      {preview && <div className="mt-3" data-testid="howto-download-preview"><p className="text-[10px] uppercase tracking-widest text-muted-foreground mb-1">Preview · {preview.label}</p><img src={preview.url} alt={preview.label} className="max-h-72 rounded-xl border border-border" /></div>}
    </div>
  );
};
